import { Nullable, Project } from "@brg/api";
import { ComputedProject } from "./types/computed/ComputedProject";

// ?
/**
 * Предикат опубликованных проектов
 *
 * @param v
 * @constructor
 */
export const ProjectStatusPublished = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && ([1, 6, 7].includes(v.status));

export const ProjectStatusVisible = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>,
  isMe?: boolean,
): boolean => !!v && ((v?.status === 10 && isMe) || v?.status !== 10);


/**
 * Предикат опубликованных проектов
 *
 * @param v
 * @constructor
 */
 export const ProjectOnDisplay = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => {
  //@ts-ignore
  if (!v || (!v.approvals && !v.contexts) || !!v?.cardId) {
   return false;
  }

  //@ts-ignore
  const { contexts } = v;
  const hasContexts = !!contexts?.filter((i:string) => i !== 'places' && i !== 'hsedesigntemp')?.length; 
  //@ts-ignore
  const { approvals } = v;
  const contextMap = approvals?.reduce((result: any, {
    contextService,
    isApproved,
    accountId,
  }: {
   contextService: string,
   isApproved: boolean,
   accountId: string
  }) => {
   return {
    ...result,
    [contextService]: {
     isApproved,
     accountId,
    }
   }
  }, {});
  //@ts-ignore
  return Object?.entries(contextMap)?.some(([key, { isApproved }]) => key.toLowerCase() !== 'places' && key.toLowerCase() !== 'hsedesigntemp' && isApproved) || hasContexts ;
}

/**
 * Предикат проектов - черновиков
 *
 * @param v
 * @constructor
 */
 export const ProjectStatusDrafts = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && v.status === 0;

/**
 * Предикат проектов - удаленных
 *
 * @param v
 * @constructor
 */
 export const ProjectStatusDeleted = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && v.status === 8;

/**
 * Предикат проектов - черновиков
 *
 * @param v
 * @constructor
 */
export const ProjectStatusDraftsAuthor = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>, designerId: string
): boolean => !!v && v?.status === 0 && (v?.authorId === designerId || v?.coAuthorIds?.indexOf(designerId) !== -1);

/**
 * Предикат проектов - черновиков
 *
 * @param v
 * @constructor
 */
 export const ProjectStatusDraftsCreator = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>, designerId: string
): boolean => !!v && v?.status === 0 && (v?.authorId !== designerId && v?.coAuthorIds?.indexOf(designerId) === -1);

/**
 * Предикат проектов - на модерации
 *
 * @param v
 * @constructor
 */
export const ProjectStatusUnderModeration = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && v.status === 5;

/**
 * Предикат проектов - креатора
 *
 * @param v
 * @constructor
 */
export const ProjectStatusCreator = (
  v: Nullable<Project | Project<"Global"> | ComputedProject | any>
): boolean =>
  !!v &&
  (v.status === 1 || v.status === 6 || v.status === 7) &&
  v.creatorId !== v.authorId;
import { Nullable, Project } from "@brg/api";
import { ComputedProject } from "./types/computed/ComputedProject";

// ?
/**
 * Предикат опубликованных проектов
 *
 * @param v
 * @constructor
 */
export const ProjectStatusPublished = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && ([1, 6, 7].includes(v.status));

export const ProjectStatusVisible = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>,
  isMe?: boolean,
): boolean => !!v && ((v?.status === 10 && isMe) || v?.status !== 10);


/**
 * Предикат опубликованных проектов
 *
 * @param v
 * @constructor
 */
 export const ProjectOnDisplay = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => {
  //@ts-ignore
  if (!v || (!v.approvals && !v.contexts) || !!v?.cardId) {
   return false;
  }

  //@ts-ignore
  const { contexts } = v;
  const hasContexts = !!contexts?.filter((i:string) => i !== 'places' && i !== 'hsedesigntemp')?.length; 
  //@ts-ignore
  const { approvals } = v;
  const contextMap = approvals?.reduce((result: any, {
    contextService,
    isApproved,
    accountId,
  }: {
   contextService: string,
   isApproved: boolean,
   accountId: string
  }) => {
   return {
    ...result,
    [contextService]: {
     isApproved,
     accountId,
    }
   }
  }, {});
  //@ts-ignore
  return Object?.entries(contextMap)?.some(([key, { isApproved }]) => key.toLowerCase() !== 'places' && key.toLowerCase() !== 'hsedesigntemp' && isApproved) || hasContexts ;
}

/**
 * Предикат проектов - черновиков
 *
 * @param v
 * @constructor
 */
 export const ProjectStatusDrafts = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && v.status === 0;

/**
 * Предикат проектов - удаленных
 *
 * @param v
 * @constructor
 */
 export const ProjectStatusDeleted = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && v.status === 8;

/**
 * Предикат проектов - черновиков
 *
 * @param v
 * @constructor
 */
export const ProjectStatusDraftsAuthor = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>, designerId: string
): boolean => !!v && v?.status === 0 && (v?.authorId === designerId || v?.coAuthorIds?.indexOf(designerId) !== -1);

/**
 * Предикат проектов - черновиков
 *
 * @param v
 * @constructor
 */
 export const ProjectStatusDraftsCreator = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>, designerId: string
): boolean => !!v && v?.status === 0 && (v?.authorId !== designerId && v?.coAuthorIds?.indexOf(designerId) === -1);

/**
 * Предикат проектов - на модерации
 *
 * @param v
 * @constructor
 */
export const ProjectStatusUnderModeration = (
  v: Nullable<Project | Project<"Global"> | ComputedProject>
): boolean => !!v && v.status === 5;

/**
 * Предикат проектов - креатора
 *
 * @param v
 * @constructor
 */
export const ProjectStatusCreator = (
  v: Nullable<Project | Project<"Global"> | ComputedProject | any>
): boolean =>
  !!v &&
  (v.status === 1 || v.status === 6 || v.status === 7) &&
  v.creatorId !== v.authorId;
